import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LoadingModule } from '@core/components/loading/loading.module';
import { IonicModule } from '@ionic/angular';
import { TranslocoModule } from '@ngneat/transloco';
import { ButtonComponent } from './components/button/button.component';
import { HeaderComponent } from './components/header/header.component';
import { ImagePreviewModalComponent } from './components/image-preview-modal/image-preview-modal.component';
import { PhoneCallModalComponent } from './components/phone-call-modal/phone-call-modal.component';
import { PlaceholderComponent } from './components/placeholder/placeholder.component';
import { TabsComponent } from './components/tabs/tabs.component';
import { AdminImageLoaderUrl } from './pipes/admin-image-loader.pipe';
import { CategoryNamePipe } from './pipes/category-name.pipe';
import { CountryFlagPipe } from './pipes/country-flag.pipe';
import { DocLoaderUrlPipe } from './pipes/doc-loader.pipe';
import { EditionRatesPipe } from './pipes/edition-rates.pipe';
import { EditionPipe } from './pipes/edition.pipe';
import { FileLoaderUrl } from './pipes/file-loader.pipe';
import { ImageLoaderUrl } from './pipes/message-image-loader.pipe';
import { PremiumPackPipe } from './pipes/premium-pack.pipe';
import { RatePricePipe } from './pipes/rate-price.pipe';
import { SmartCurrencyPipe } from './pipes/smart-currency.pipe';
import { UserPhotoPipe } from './pipes/user-photo.pipe';

const COMPONENTS = [
  TabsComponent,
  ButtonComponent,
  HeaderComponent,
  PlaceholderComponent,
  ImagePreviewModalComponent,
  PhoneCallModalComponent,
];
const PIPES = [
  EditionRatesPipe,
  ImageLoaderUrl,
  CountryFlagPipe,
  DocLoaderUrlPipe,
  PremiumPackPipe,
  EditionPipe,
  FileLoaderUrl,
  AdminImageLoaderUrl,
  CategoryNamePipe,
  SmartCurrencyPipe,
  UserPhotoPipe,
  RatePricePipe,
];
@NgModule({
  imports: [IonicModule, CommonModule, FormsModule, ReactiveFormsModule, TranslocoModule, RouterModule, LoadingModule],
  declarations: [...PIPES, ...COMPONENTS],
  exports: [...PIPES, ...COMPONENTS],
})
export class SharedModule {}
